import React from 'react';
import { Box } from '@mui/material';
import './ScrollIndicator.css';

const ScrollIndicator = () => (
  <Box className="scroll-indicator">
    <span className="mouse">
      <span className="wheel" />
    </span>
  </Box>
);

export default ScrollIndicator;